import { render, staticRenderFns } from "./BasicSummary.vue?vue&type=template&id=a7db01ac"
import script from "./BasicSummary.vue?vue&type=script&lang=js"
export * from "./BasicSummary.vue?vue&type=script&lang=js"
import style0 from "./BasicSummary.vue?vue&type=style&index=0&id=a7db01ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports